import TemplateMixin from './TemplateMixin';
import { Component, Mixins, Watch } from 'vue-property-decorator';

@Component({})
export default class GameCaptureTemplate extends Mixins(TemplateMixin) {
  canvas: HTMLCanvasElement = null;
  video: HTMLVideoElement = null;
  videojsVideoId: string = 'previewVideoElement_html5_api';
  intervalId: number = 0;
  videoCanvasSettings = {
    loaded: false,
    scaleW: 0,
    scaleH: 0
  };

  get refName(): string {
    return 'previewCanvasElement';
  }

  mounted() {
    if (this.isLive || this.isStreamPreview) this.startDrawing();
  }

  @Watch('component.w')
  @Watch('component.h')
  @Watch('component.verticalSettings.w')
  @Watch('component.verticalSettings.h')
  updateCanvasDimensions() {
    const componentWidth = this.isVertical ? this.component.verticalSettings.w : this.component.w;
    const componentHeight = this.isVertical ? this.component.verticalSettings.h : this.component.h;

    if (this.canvas) {
      this.canvas.width = componentWidth;
      this.canvas.height = componentHeight;
    }

    if (this.video?.videoHeight && this.video?.videoWidth) {
      this.videoCanvasSettings.scaleW = componentWidth / this.video.videoWidth;
      this.videoCanvasSettings.scaleH = componentHeight / this.video.videoHeight;
      this.videoCanvasSettings.loaded = true;
    }
  }

  @Watch('isLive')
  @Watch('isStreamPreview')
  isLiveHandler(newVal) {
    newVal ? this.startDrawing() : this.stopDrawing();
  }

  startDrawing() {
    if (this.intervalId) return;

    this.videoCanvasSettings.loaded = false;
    this.canvas = this.$refs[this.refName] as HTMLCanvasElement;
    this.video = document.getElementById(this.videojsVideoId) as HTMLVideoElement;
    this.intervalId = setInterval(this.updateCanvas, 1000 / 30);
    this.loadCanvasSettings();
  }

  loadCanvasSettings() {
    if (!this.isLive && !this.isStreamPreview) {
      return;
    }

    if (!this.video || !this.video.videoHeight || !this.video.videoWidth) {
      setTimeout(this.loadCanvasSettings, 3000);
      return;
    }

    this.updateCanvasDimensions();
  }

  stopDrawing() {
    clearInterval(this.intervalId);
    this.intervalId = 0;
    const ctx = this.canvas.getContext("2d");
    ctx.clearRect(0, 0, this.component.w, this.component.h);
  }

  updateCanvas() {
    if (!this.video || this.video.paused || !this.videoCanvasSettings.loaded) return;

    const ctx = this.canvas.getContext("2d");
    ctx.clearRect(0, 0, this.component.w, this.component.h);
    ctx.drawImage(
      this.video,
      0,
      0,
      this.video.videoWidth * this.videoCanvasSettings.scaleW,
      this.video.videoHeight * this.videoCanvasSettings.scaleH
    );
  }
}
